var _ellipse, _circle, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoStyleV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 58,
    viewBox: "0 0 59 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.5,
    cy: 29,
    rx: 29.2437,
    ry: 29,
    fill: "url(#paint0_linear_493_12023)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38.5483,
    cy: 22.6104,
    r: 8,
    fill: "#F2F2F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.5673 24.6002C37.7315 24.6002 37.3611 24.0018 37.3611 22.7386V22.4536C37.3611 21.1999 37.7315 20.5825 38.5483 20.5825C39.3747 20.5825 39.7356 21.2094 39.7356 22.4536V22.7291C39.7356 23.9828 39.4031 24.6002 38.5673 24.6002ZM38.5103 26.1104C40.4479 26.1104 41.6827 24.8471 41.6827 22.6911V22.4251C41.6827 20.2216 40.3339 19.1104 38.5483 19.1104C36.7532 19.1104 35.414 20.3166 35.414 22.4631V22.7481C35.414 24.8851 36.6107 26.1104 38.5103 26.1104Z",
    fill: "#1A1A1A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.5079 32.2001C38.4797 32.2003 38.4515 32.2004 38.4233 32.2004C33.5034 32.2004 29.457 28.4605 28.972 23.6685C28.7853 23.7524 28.5783 23.7991 28.3604 23.7991C27.6008 23.7991 26.985 24.4148 26.985 25.1744V26.3507L14.2432 34.8452C11.9541 36.3713 13.0345 39.9396 15.7857 39.9396H40.9332C43.6844 39.9396 44.7648 36.3713 42.4756 34.8452L38.5079 32.2001ZM29.0762 20.9938C29.2444 20.0666 29.5471 19.1863 29.9635 18.3738C29.4688 18.1719 28.9276 18.0607 28.3604 18.0607C26.0161 18.0607 24.1158 19.961 24.1158 22.3052C24.1158 23.0648 24.7316 23.6806 25.4912 23.6806C26.2508 23.6806 26.8665 23.0648 26.8665 22.3052C26.8665 21.4802 27.5353 20.8114 28.3604 20.8114C28.6197 20.8114 28.8636 20.8775 29.0762 20.9938ZM28.3594 28.7404L15.7691 37.134C15.7618 37.1388 15.7567 37.1428 15.7532 37.1458C15.7534 37.1514 15.7544 37.159 15.757 37.1676C15.7596 37.1761 15.763 37.183 15.7659 37.1878C15.7704 37.1884 15.7769 37.1888 15.7857 37.1888H40.9332C40.9372 37.1888 40.9408 37.1887 40.9439 37.1886C40.9475 37.1884 40.9505 37.1881 40.953 37.1878C40.9559 37.183 40.9592 37.1761 40.9618 37.1676C40.9629 37.1641 40.9637 37.1608 40.9643 37.1577C40.9651 37.1532 40.9656 37.1491 40.9657 37.1458C40.9637 37.1441 40.9613 37.1422 40.9582 37.1399C40.9558 37.1381 40.953 37.1361 40.9498 37.134L28.3594 28.7404Z",
    fill: "#1A1A1A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_493_12023",
    x1: 43.8781,
    y1: 4.35,
    x2: 0.758379,
    y2: 69.2088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2D4BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAF4EE",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoStyleV2);
export default __webpack_public_path__ + "static/media/no_style_v2.c2790c20fc78f77b08345b0472c2266a.svg";
export { ForwardRef as ReactComponent };